var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#222",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pause_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 47.5v-25a2.5 2.5 0 0 1 5 0v25a2.5 2.5 0 0 1-5 0ZM43 47.5v-25a2.5 2.5 0 0 1 5 0v25a2.5 2.5 0 0 1-5 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pause_svg__a",
    x: 20,
    y: 17,
    width: 33,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2429_74224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2429_74224",
    result: "shape"
  })))));
};
export { SvgPause as ReactComponent };
export default "<svg width=\"70\" height=\"70\" viewBox=\"0 0 70 70\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t\t<rect width=\"70\" height=\"70\" rx=\"35\" fill=\"#222222\" fill-opacity=\"0.5\"/>\n\t\t\t\t\t\t<g filter=\"url(#filter0_d_2429_74224)\">\n\t\t\t\t\t\t<path d=\"M23 47.5V22.5C23 21.1193 24.1193 20 25.5 20C26.8807 20 28 21.1193 28 22.5V47.5C28 48.8807 26.8807 50 25.5 50C24.1193 50 23 48.8807 23 47.5Z\" fill=\"white\"/>\n\t\t\t\t\t\t<path d=\"M43 47.5V22.5C43 21.1193 44.1193 20 45.5 20C46.8807 20 48 21.1193 48 22.5V47.5C48 48.8807 46.8807 50 45.5 50C44.1193 50 43 48.8807 43 47.5Z\" fill=\"white\"/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t<filter id=\"filter0_d_2429_74224\" x=\"20\" y=\"17\" width=\"33\" height=\"38\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n\t\t\t\t\t\t<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n\t\t\t\t\t\t<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n\t\t\t\t\t\t<feOffset dx=\"1\" dy=\"1\"/>\n\t\t\t\t\t\t<feGaussianBlur stdDeviation=\"2\"/>\n\t\t\t\t\t\t<feComposite in2=\"hardAlpha\" operator=\"out\"/>\n\t\t\t\t\t\t<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0\"/>\n\t\t\t\t\t\t<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_2429_74224\"/>\n\t\t\t\t\t\t<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_2429_74224\" result=\"shape\"/>\n\t\t\t\t\t\t</filter>\n\t\t\t\t\t\t</defs>\n\t\t\t\t\t</svg>";